/* TwoClickAppInstallSiteAndPlanSelector.tsx generated by @compiled/babel-plugin v0.36.0 */
import _capitalize from "lodash/capitalize";
import { ax, ix, CC, CS } from "@compiled/react/runtime";
/* eslint-disable max-lines-per-function */
/* eslint-disable complexity */
import { Box, media, xcss } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import { BodySmall, getParentEditionFromOfferings } from '@atlassian/mpac-primitives';
import { SiteSelectorError, SiteSelectorSelect } from '@atlassian/mpac-site-selection';
import { MarketplaceStoreEditionType } from '@atlassian/mpac-types/graphql-gateway-types';
import { ExternalLink } from '@atlassian/mpac-ui';
import { appSupportsAdvancedEdition, isSandboxInstance } from '@atlassian/mpac-utils';
import { memo } from 'react';
import { AppEditionsSandboxSectionMessages } from '../../AppEditionsSandboxSectionMessages';
import { TEST_IDS } from '../../constants';
import { MultiInstancePricingSectionMessage } from '../../MultiInstancePricingSectionMessage';
import { PlanSelector } from '../../PlanSelector';
import { ScreenTitle } from '../../ScreenTitle';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _7 = "@media (min-width:64rem){._10m4frkr{flex-grow:0.6}._1vdkkb7n{flex-shrink:1}._1wznf1ug{flex-basis:0%}._zp8115vq{overflow-x:hidden}._1mbp15vq{overflow-y:hidden}._2oz42wrg{border-radius:var(--_7ouv5q)}._4ap3r01l{background-color:var(--ds-background-input-pressed,#fff)}}";
const _6 = "._1bah1yb4{justify-content:space-between}";
const _5 = "._4t3ioskh{height:calc(100% - 24px)}";
const _4 = "._2lx21bp4{flex-direction:column}";
const _3 = "._1e0c1txw{display:flex}";
const _2 = "@media not all and (min-width:48rem){._1s6bukr8{margin:var(--ds-space-negative-400,-2pc)}}";
const _ = "._ect418aq{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const {
  Free,
  Standard,
  Advanced
} = MarketplaceStoreEditionType;
const siteSelectorScreenStyles = null;
const siteSelectorContent = xcss({
  display: 'flex',
  flexDirection: 'column',
  gap: 'space.300',
  [media.above.sm]: {
    gap: 'space.400'
  }
});
const siteSelectorContainer = null;
const renderTrialUpgradeMessage = (appName, currentEdition, nextEdition, links, orgId) => {
  const dataTestId = currentEdition === Free ? TEST_IDS.TWO_CLICK_PLAN_SELECTOR_FREE_BOUGHT_SECTION_MESSAGE : TEST_IDS.TWO_CLICK_PLAN_SELECTOR_STANDARD_BOUGHT_SECTION_MESSAGE;
  return /*#__PURE__*/_jsx(SectionMessage, {
    appearance: "information",
    children: /*#__PURE__*/_jsxs(BodySmall, {
      "data-testid": dataTestId,
      children: ["You're already on the ", _capitalize(currentEdition), " edition of ", appName, ". Try the", ' ', _capitalize(nextEdition), " edition free for 30 days. You can cancel the trial or modify your edition at any time in Admin Hub ", '>', " Billing ", '>', ' ', /*#__PURE__*/_jsx(ExternalLink, {
        href: "".concat(links.adminHub.expand({}), "/o/").concat(orgId, "/billing-preview"),
        children: "Subscriptions"
      }), "."]
    })
  });
};
const renderManageAppMessage = (appName, edition, links, cloudId) => {
  const dataTestId = edition === Standard ? TEST_IDS.TWO_CLICK_PLAN_SELECTOR_TERMINAL_STANDARD_BOUGHT_SECTION_MESSAGE : TEST_IDS.TWO_CLICK_PLAN_SELECTOR_ADVANCED_BOUGHT_SECTION_MESSAGE;
  return /*#__PURE__*/_jsx(SectionMessage, {
    children: /*#__PURE__*/_jsxs(BodySmall, {
      "data-testid": dataTestId,
      children: ["You're already on the ", _capitalize(edition), " edition of ", appName, ". To manage this app, go to Admin Hub ", '> ', "Product ", '>', ' ', /*#__PURE__*/_jsx(ExternalLink, {
        href: "".concat(links.adminHub.expand({}), "/s/").concat(cloudId, "/user-connected-apps/"),
        children: "Connected apps"
      }), "."]
    })
  });
};
const renderSectionMessage = (editionInstalledOnSelectedSite, appName, links, cloudId, isAdvancedEditionAvailable, orgId) => {
  if (editionInstalledOnSelectedSite === Free) {
    return renderTrialUpgradeMessage(appName, Free, Standard, links, orgId);
  } else if (editionInstalledOnSelectedSite === Standard) {
    if (isAdvancedEditionAvailable) {
      return renderTrialUpgradeMessage(appName, Standard, Advanced, links, orgId);
    }
    return renderManageAppMessage(appName, Standard, links, cloudId);
  } else if (editionInstalledOnSelectedSite === Advanced) {
    return renderManageAppMessage(appName, Advanced, links, cloudId);
  }
  return null;
};
export const TwoClickAppInstallSiteAndPlanSelector = /*#__PURE__*/memo(props => {
  var _selectedSiteAndProdu, _hostStatusPromise$ho;
  const {
    appDetails,
    links,
    mpacBaseUrl,
    editionInstalledOnSelectedSite,
    selectedSiteAndProduct,
    editionTypes,
    selectedPlan,
    setSelectedPlan,
    showAppPlans,
    isFreeApp,
    canUserInstallApp,
    appCompatibilities,
    availableSitesPromise,
    appInstallPermissionPromise,
    onSiteChange,
    isAppInstalled,
    hostStatusPromise,
    installedAppDetailsResult,
    orgId,
    enterprisePlanPurchased,
    appHasMultiInstanceEntitlement,
    eligibleOfferings,
    isAdvancedEditionsWithHAMSBilling
  } = props;
  const allEditions = (editionTypes === null || editionTypes === void 0 ? void 0 : editionTypes.map(edition => ({
    label: edition,
    value: edition
  }))) || [];
  const appPricingDetailsLink = links.appPricingDetails.expand({
    appKey: appDetails.appKey
  });
  const showPlanSelector = showAppPlans && allEditions.length > 1;
  const cloudId = selectedSiteAndProduct === null || selectedSiteAndProduct === void 0 ? void 0 : (_selectedSiteAndProdu = selectedSiteAndProduct.site) === null || _selectedSiteAndProdu === void 0 ? void 0 : _selectedSiteAndProdu.cloudId;
  const isSandbox = isSandboxInstance(hostStatusPromise === null || hostStatusPromise === void 0 ? void 0 : (_hostStatusPromise$ho = hostStatusPromise.hostStatusResult) === null || _hostStatusPromise$ho === void 0 ? void 0 : _hostStatusPromise$ho.marketplaceStore.hostStatus.instanceType);
  const parentEdition = getParentEditionFromOfferings(eligibleOfferings);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_ect418aq _1s6bukr8"]),
      children: [/*#__PURE__*/_jsx(ScreenTitle, {
        title: showPlanSelector ? 'Select an edition and site' : 'Select a site',
        stepInfo: "Step 1 of 2"
      }), /*#__PURE__*/_jsxs(Box, {
        xcss: siteSelectorContent,
        children: [showPlanSelector && /*#__PURE__*/_jsx(PlanSelector, {
          editions: allEditions,
          selectedPlanType: selectedPlan,
          setSelectedPlanType: setSelectedPlan,
          appPricingDetailsLink: appPricingDetailsLink
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_3, _4, _5, _6, _7]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1e0c1txw _2lx21bp4 _4t3ioskh _1bah1yb4 _10m4frkr _1vdkkb7n _1wznf1ug _zp8115vq _1mbp15vq _2oz42wrg _4ap3r01l"]),
            style: {
              "--_7ouv5q": ix("var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-100, 8px)", " 0 0"))
            },
            children: /*#__PURE__*/_jsx(SiteSelectorSelect, {
              appDetails: appDetails,
              isFreeApp: isFreeApp,
              canUserInstallApp: canUserInstallApp,
              availableSitesPromise: availableSitesPromise,
              appInstallPermissionPromise: appInstallPermissionPromise,
              firstCompatibleProduct: appCompatibilities[0],
              mpacBaseUrl: mpacBaseUrl,
              selectedSiteAndProduct: selectedSiteAndProduct,
              onSiteChange: onSiteChange,
              isAppInstalled: isAppInstalled,
              hostStatusPromise: hostStatusPromise,
              installedAppDetailsResult: installedAppDetailsResult,
              supportsTwoStepInstallation: true
            })
          })]
        }), isSandbox && !!parentEdition && showAppPlans && !isAppInstalled && /*#__PURE__*/_jsx(AppEditionsSandboxSectionMessages, {
          eligibleOfferings: eligibleOfferings,
          selectedEditionTypeValue: selectedPlan.value
        }), isAdvancedEditionsWithHAMSBilling && /*#__PURE__*/_jsx(SiteSelectorError.AppEditionsDisabledForHAMS, {
          noMargin: true
        }), appHasMultiInstanceEntitlement && showPlanSelector && enterprisePlanPurchased && !isSandbox && /*#__PURE__*/_jsx(MultiInstancePricingSectionMessage, {
          enterprisePlan: enterprisePlanPurchased,
          selectedPlan: selectedPlan.value,
          eligibleOfferings: eligibleOfferings,
          isStepReviewAndInstall: false
        }), editionInstalledOnSelectedSite && cloudId && canUserInstallApp && isAppInstalled && showPlanSelector && renderSectionMessage(editionInstalledOnSelectedSite, appDetails.appName, links, cloudId, appSupportsAdvancedEdition(editionTypes), orgId), appHasMultiInstanceEntitlement && !showPlanSelector && !isSandbox && /*#__PURE__*/_jsx(SectionMessage, {
          appearance: "information",
          children: /*#__PURE__*/_jsx(BodySmall, {
            children: "You can add this app directly to your instance as it's already purchased for multiple instances."
          })
        })]
      })]
    })]
  });
});
TwoClickAppInstallSiteAndPlanSelector.displayName = 'TwoClickAppInstallSiteAndPlanSelector';